(function() {
  'use strict';

  function injectModalVideo(drawerId) {
    const drawer = document.getElementById(drawerId);
    if (!drawer) return;
    const slot = drawer.querySelector('[id$="-video-slot"]');
    if (!slot || slot.querySelector('video, iframe')) return;
    const configScript = document.querySelector('[data-rc-modal-video-config]');
    if (!configScript) return;
    let config;
    try {
      config = JSON.parse(configScript.textContent);
    } catch (e) {
      return;
    }
    const playColor = config.playButtonColor || '#ffffff';
    if (config.type === 'uploaded' && config.sources && config.sources.length) {
      const video = document.createElement('video');
      video.controls = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.style.width = '100%';
      video.style.aspectRatio = config.aspectRatio || '16/9';
      video.style.display = 'block';
      video.style.borderRadius = 'var(--rounded)';
      config.sources.forEach(function(s) {
        const src = document.createElement('source');
        src.src = s.url;
        src.type = s.type || 'video/mp4';
        video.appendChild(src);
      });
      if (config.poster) {
        video.poster = config.poster;
      }
      slot.appendChild(video);
    } else if (config.type === 'external' && config.host && config.videoId) {
      const embed = document.createElement('div');
      embed.style.position = 'relative';
      embed.style.aspectRatio = config.aspectRatio || '16/9';
      embed.style.borderRadius = 'var(--rounded)';
      embed.style.overflow = 'hidden';
      let embedUrl = '';
      if (config.host === 'youtube') {
        embedUrl = 'https://www.youtube.com/embed/' + config.videoId + '?autoplay=0';
      } else if (config.host === 'vimeo') {
        embedUrl = 'https://player.vimeo.com/video/' + config.videoId;
      }
      if (embedUrl) {
        const iframe = document.createElement('iframe');
        iframe.src = embedUrl;
        iframe.style.position = 'absolute';
        iframe.style.inset = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        embed.appendChild(iframe);
      }
      slot.appendChild(embed);
    }
  }

  function initLearnMoreDrawer() {
    document.addEventListener('click', function(e) {
      const target = e.target.closest('[aria-controls]');
      if (!target) return;
      const drawerId = target.getAttribute('aria-controls');
      if (!drawerId || drawerId.indexOf('rc-learn-more-drawer-') !== 0) return;
      injectModalVideo(drawerId);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLearnMoreDrawer);
  } else {
    initLearnMoreDrawer();
  }
  document.addEventListener('shopify:section:load', initLearnMoreDrawer);
})();
